// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhn_a bic_ea bic_a","LoadingSwitch__init":"bhn_b bic_a bic_w bic_j bic_ul bic_um bic_fm"};